import React from "react";
import "./raceTitleBanner.css";

/** Racing checkered tails — denser near the bar, scatter outward. */
function BannerFlag({ side }) {
  const cells = [
    [0, 0],
    [0, 2],
    [0, 4],
    [0, 6],
    [1, 1],
    [1, 3],
    [1, 5],
    [2, 0],
    [2, 2],
    [2, 4],
    [2, 6],
    [3, 1],
    [3, 3],
    [3, 5],
    [4, 0],
    [4, 2],
    [4, 4],
    [4, 6],
    [5, 1],
    [5, 3],
    [5, 5],
    [6, 0],
    [6, 2],
    [6, 5],
    [7, 1],
    [7, 4],
    [8, 0],
    [8, 3],
    [8, 6],
    [9, 2],
    [9, 5],
    [10, 1],
    [10, 4],
    [11, 3],
  ];

  const size = 8;
  const viewW = 12 * size;
  const viewH = 7 * size;

  return (
    <svg
      className={`race-title-banner__flag race-title-banner__flag--${side}`}
      viewBox={`0 0 ${viewW} ${viewH}`}
      aria-hidden="true"
      focusable="false"
    >
      {cells.map(([c, r]) => (
        <rect
          key={`${side}-${c}-${r}`}
          x={c * size}
          y={r * size}
          width={size}
          height={size}
          fill="currentColor"
        />
      ))}
    </svg>
  );
}

export default function RaceTitleBanner({ children, as: Tag = "h1" }) {
  return (
    <div className="race-title-banner">
      <BannerFlag side="left" />
      <Tag className="race-title-banner__title">{children}</Tag>
      <BannerFlag side="right" />
    </div>
  );
}
